{
  "commonHeader": {
    "toggleSidebar": "사이드바 전환",
    "cartLoading": "장바구니 로드 중",
    "cart": "장바구니",
    "aicForAdmin": {
      "ariaLabel": "관리자용 AI"
    },
    "usersResults": "사용자, 결과 {0}개",
    "settingsResults": "설정, 결과 {0}개",
    "navigationResults": "탐색, 결과 {0}개",
    "learnMoreAbout": "{0} 자세히 알아보기",
    "close": "닫기",
    "products": "제품",
    "moreActions": "추가 작업",
    "search": "검색",
    "searchPlaceholderAll": "사용자, 계정 설정 또는 탐색 검색",
    "searchPlaceholderUsers": "사용자 또는 탐색 검색",
    "searchPlaceholderSettings": "계정 설정 또는 탐색 검색",
    "searchPlaceholderNav": "탐색 검색"
  },
  "footerCopyright": {
    "language": "언어 {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "관리자 메뉴"
    }
  },
  "shared": {
    "close": "닫기",
    "sideMenu": {
      "personalAria": "개인 메뉴",
      "adminAria": "관리자 메뉴",
      "mainNav": "기본 탐색",
      "submenu": "하위 메뉴",
      "pinnedSection": "{0} 고정됨",
      "sideMenuAria": "사이드 메뉴",
      "pinItem": "{0} 고정",
      "unpinItem": "{0} 고정 해제",
      "reorderGrabbed": "{0} 재정렬 중, 잡힘. 위아래 화살표 키로 이동하고 스페이스 또는 Enter로 놓으며 Esc로 취소합니다.",
      "reorderIdle": "{0} 재정렬. 스페이스 또는 Enter를 눌러 잡습니다.",
      "hintHandlePin": "Tab을 눌러 끌기 핸들과 고정 버튼에 접근",
      "hintHandle": "Tab을 눌러 끌기 핸들에 접근",
      "hintPin": "Tab을 눌러 고정 버튼에 접근",
      "upgradeToPro": "Pro로 업그레이드"
    },
    "item": "항목"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "새로운 환경 사용해 보기"
    }
  },
  "aicGuide": {
    "common": {
      "close": "닫기"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "이제 디비전을 사용할 수 있습니다"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "외부 계정 관리"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "주소록이 고객 디렉터리로 변경됩니다"
    }
  },
  "feedback": {
    "itemLableForProductArea": "제품 영역",
    "itemLableForFeedback": "피드백"
  }
}
